import { useMutation } from "@apollo/client/react";import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { useVisita } from "../../../../../../context/VisitaContext";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import SAVE_PARAMETROS_CONTROL_CLINICO_AP, { adaptAddVisitaParametrosControlClinicoInput } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaParametrosControlClinicoAP";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function ParametrosControlClinicoAP({ esUrgencia, readOnly, onSaveRef, onExposeFormatted }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [save] = useMutation(SAVE_PARAMETROS_CONTROL_CLINICO_AP);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      if (esUrgencia) newInput.required = false;

      if (readOnly) newInput.disabled = true;

      return newInput;
    });
  }, [readOnly, esUrgencia]);

  const handleChange = useCallback((name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }, []);

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { ...adaptAddVisitaParametrosControlClinicoInput(formData) } });

    const idParametrosControlClinico = data?.saveVisitaParametrosControlClinicoAP?.idParametrosControlClinico;
    if (!idParametrosControlClinico) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData,
      idParametrosControlClinico: idParametrosControlClinico
    }));

  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'parametrosControlClinico',
      stepName: 'Parametros de control clínico',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox>
      <Grid container spacing={2}>
        {formattedInputs.map((input) =>
        <Grid size={{ xs: 12 }} key={input.name}>
            <RenderInputByTypeMobile
            input={input}
            value={formData[input.name]}
            handleChange={handleChange} />
          
          </Grid>
        )}
      </Grid>
    </CardBox>);

}

const inputs = [
{
  name: "comoSeSintio",
  displayName: "¿Cómo se sintió los últimos días?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "modificacionesEstado",
  displayName: "¿Hubo modificaciones en su estado de ánimo o actividad física?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "sienteDolor",
  displayName: "¿Siente o tuvo algún tipo de dolor?",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "tuvoFiebre",
  displayName: "¿Tuvo fiebre?",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "comoEstaPresion",
  displayName: "¿Cómo está su presión?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "situacionClinica",
  displayName: "¿Tuvo alguna situación clínica que debamos avisar a su médico?",
  type: "long_string",
  maxLength: 250,
  required: true
}];